import React from "react";
import UserTopMenu from "./UserTopMenu";
import UserMenu from "./UserMenu";
import { Helmet } from "react-helmet";
import { isAuthenticated, logout } from "../../auth/helper";
import { NavLink, useNavigate } from "react-router-dom";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const UserBase = ({ title = "Dashboard", children }) => {
  const navigate = useNavigate();

  // Login user details
  const authData = isAuthenticated();
  const user = authData?.user || authData || {};

  const fullName =
    user.name ||
    user.displayName ||
    `${user.firstname || user.firstName || user.given_name || ""} ${
      user.lastname || user.lastName || user.family_name || ""
    }`.trim();

  const nameParts = fullName.trim().split(/\s+/);

  const firstname =
    user.firstname ||
    user.firstName ||
    user.given_name ||
    nameParts[0] ||
    "Scope";

  const lastname =
    user.lastname ||
    user.lastName ||
    user.family_name ||
    nameParts.slice(1).join(" ") ||
    "Delegate";

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div>
      <Helmet>
        <link
          href="/adminAssets/vendor/fontawesome-free/css/all.min.css"
          rel="stylesheet"
          type="text/css"
        />

        <link
          href="https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i"
          rel="stylesheet"
        />

        <link
          href="/adminAssets/css/sb-admin-2.min.css"
          rel="stylesheet"
        />

        <script src="/adminAssets/vendor/jquery/jquery.min.js"></script>
        <script src="/adminAssets/vendor/bootstrap/js/bootstrap.js"></script>
      </Helmet>

      <div
        id="wrapper"
        style={{
          display: "flex",
          minHeight: "100vh",
          width: "100%",
          overflowY: "auto",
        }}
      >
        <UserMenu />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <UserTopMenu
              firstname={firstname}
              lastname={lastname}
            />

            <div className="container-fluid">
              <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">{title}</h1>
              </div>

              {children}
            </div>
          </div>

          <footer className="sticky-footer bg-primary">
            <div className="container my-auto">
              <div className="copyright text-center my-auto text-white">
                <span>
                  Copyright &copy; Scope Health UK 2026 | Powered By Maylancer
                  Techios Pvt Ltd
                </span>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      <div
        className="modal fade"
        id="logoutModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="logoutModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="logoutModalLabel">
                Ready to Leave?
              </h5>

              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              Select "Logout" below if you are ready to end your current
              session.
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                type="button"
                data-dismiss="modal"
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                type="button"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBase;